<template>
  <!-- CONTENT -->

  <div
    :id="'screen'"
    :style="{opacity: opacity}"
  >
    <Background />

    <main
      class="scrollable container"
      :style="{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
      }"
    >
      <TransactionSvg :style="{marginBottom: '30px'}" />
      <h3 :style="{marginBottom: '30px'}">
        Your payment has been <br />
        processed!
      </h3>
      <div :style="{marginBottom: '10px'}">
        <span :style="{fontSize: '28px'}">364</span>
        <span :style="{fontSize: '16px'}">.00 USD</span>
      </div>
      <p
        class="t16"
        :style="{marginBottom: '30px'}"
      >
        Labore sunt culpa excepteur culpa ipsum. Labore <br />
        occaecat ex nisi mollit.
      </p>
      <div
        class="row-center"
        :style="{gap: '17px', width: '100%'}"
      >
        <Button
          :title="'Send Receipt'"
          :colorSchema="'secondary'"
          :containerStyle="{width: '100%'}"
        />
        <Button
          :title="'Done'"
          :containerStyle="{width: '100%'}"
          @click="$router.push(routes.TAB_NAVIGATOR)"
        />
      </div>
    </main>
  </div>
</template>

<script setup>
// components
import {Button} from '@/components';
import {Background} from '@/components';

// svg
import {TransactionSvg} from '@/assets/svg';

// other
import {routes} from '@/routes';
import {useOpacity} from '@/hooks';

const opacity = useOpacity();
</script>
